import React from 'react';
import { Option } from '../../kingpin/atoms/ContextMenu';

const DashboardGadgetFilteringButton = ({ open }: { open: () => void }) => (
  <Option label={'Edit Filters'} icon={'edit-filled'} onClick={open} />
);

export default DashboardGadgetFilteringButton;
